import { render, staticRenderFns } from "./SupportTicketModal.vue?vue&type=template&id=1ce3e9b4&scoped=true"
import script from "./SupportTicketModal.vue?vue&type=script&lang=js"
export * from "./SupportTicketModal.vue?vue&type=script&lang=js"
import style0 from "./SupportTicketModal.vue?vue&type=style&index=0&id=1ce3e9b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce3e9b4",
  null
  
)

export default component.exports